// extracted by mini-css-extract-plugin
export default {"wrapper":"Comic_wrapper__QX+CO","info":"Comic_info__1uZ8P"};